import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4fefb329 = () => interopDefault(import('../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _aecb101e = () => interopDefault(import('../pages/documents.vue' /* webpackChunkName: "pages/documents" */))
const _662edd51 = () => interopDefault(import('../pages/documents/_area/index.vue' /* webpackChunkName: "pages/documents/_area/index" */))
const _19c6c723 = () => interopDefault(import('../pages/messages.vue' /* webpackChunkName: "pages/messages" */))
const _749c2766 = () => interopDefault(import('../pages/messages/index.vue' /* webpackChunkName: "pages/messages/index" */))
const _469d1018 = () => interopDefault(import('../pages/messages/create.vue' /* webpackChunkName: "pages/messages/create" */))
const _1be0271a = () => interopDefault(import('../pages/messages/inbox.vue' /* webpackChunkName: "pages/messages/inbox" */))
const _062961b4 = () => interopDefault(import('../pages/messages/sent.vue' /* webpackChunkName: "pages/messages/sent" */))
const _058a02a2 = () => interopDefault(import('../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _e002f0b6 = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _005260a3 = () => interopDefault(import('../pages/profile/settings/index.vue' /* webpackChunkName: "pages/profile/settings/index" */))
const _97c5acca = () => interopDefault(import('../pages/requests.vue' /* webpackChunkName: "pages/requests" */))
const _650ccfde = () => interopDefault(import('../pages/requests/index.vue' /* webpackChunkName: "pages/requests/index" */))
const _620247a2 = () => interopDefault(import('../pages/requests/new/index.vue' /* webpackChunkName: "pages/requests/new/index" */))
const _bb800cf2 = () => interopDefault(import('../pages/requests/submitted.vue' /* webpackChunkName: "pages/requests/submitted" */))
const _47940014 = () => interopDefault(import('../pages/requests/new/_type.vue' /* webpackChunkName: "pages/requests/new/_type" */))
const _4fa62069 = () => interopDefault(import('../pages/auth/impersonate.vue' /* webpackChunkName: "pages/auth/impersonate" */))
const _4412894e = () => interopDefault(import('../pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _2df1b84a = () => interopDefault(import('../pages/auth/logout.vue' /* webpackChunkName: "pages/auth/logout" */))
const _d2f37488 = () => interopDefault(import('../pages/auth/registration/index.vue' /* webpackChunkName: "pages/auth/registration/index" */))
const _a057e534 = () => interopDefault(import('../pages/auth/t2t.vue' /* webpackChunkName: "pages/auth/t2t" */))
const _7a6561fb = () => interopDefault(import('../pages/download/document.vue' /* webpackChunkName: "pages/download/document" */))
const _a7e3a718 = () => interopDefault(import('../pages/idAustriaSp/callback.vue' /* webpackChunkName: "pages/idAustriaSp/callback" */))
const _059b3ce4 = () => interopDefault(import('../pages/idAustriaSp/confirmation.vue' /* webpackChunkName: "pages/idAustriaSp/confirmation" */))
const _31a91730 = () => interopDefault(import('../pages/idAustriaSp/verify.vue' /* webpackChunkName: "pages/idAustriaSp/verify" */))
const _0292b462 = () => interopDefault(import('../pages/auth/registration/update.vue' /* webpackChunkName: "pages/auth/registration/update" */))
const _5a70c502 = () => interopDefault(import('../pages/auth/registration/verify.vue' /* webpackChunkName: "pages/auth/registration/verify" */))
const _7cfed7de = () => interopDefault(import('../pages/auth/reset/password/index.vue' /* webpackChunkName: "pages/auth/reset/password/index" */))
const _b931026a = () => interopDefault(import('../pages/auth/reset/user.vue' /* webpackChunkName: "pages/auth/reset/user" */))
const _267d6a56 = () => interopDefault(import('../pages/auth/reset/username.vue' /* webpackChunkName: "pages/auth/reset/username" */))
const _40268b59 = () => interopDefault(import('../pages/auth/sso/login.vue' /* webpackChunkName: "pages/auth/sso/login" */))
const _1c39688e = () => interopDefault(import('../pages/auth/sso/verify.vue' /* webpackChunkName: "pages/auth/sso/verify" */))
const _493ef3aa = () => interopDefault(import('../pages/profile/settings/delete.vue' /* webpackChunkName: "pages/profile/settings/delete" */))
const _a251e326 = () => interopDefault(import('../pages/profile/settings/email.vue' /* webpackChunkName: "pages/profile/settings/email" */))
const _f940da4c = () => interopDefault(import('../pages/profile/settings/password.vue' /* webpackChunkName: "pages/profile/settings/password" */))
const _893d60c6 = () => interopDefault(import('../pages/auth/reset/password/verify.vue' /* webpackChunkName: "pages/auth/reset/password/verify" */))
const _70f6298b = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _c86984e6 = () => interopDefault(import('../pages/documents/detail/_id/index.vue' /* webpackChunkName: "pages/documents/detail/_id/index" */))
const _dd360eca = () => interopDefault(import('../pages/messages/detail/_id/index.vue' /* webpackChunkName: "pages/messages/detail/_id/index" */))
const _2ac0d523 = () => interopDefault(import('../pages/requests/detail/_id/index.vue' /* webpackChunkName: "pages/requests/detail/_id/index" */))
const _18d5a9d0 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _4fefb329,
    name: "account___de"
  }, {
    path: "/documents",
    component: _aecb101e,
    name: "documents___de",
    children: [{
      path: ":area",
      component: _662edd51,
      name: "documents-area___de"
    }]
  }, {
    path: "/messages",
    component: _19c6c723,
    children: [{
      path: "",
      component: _749c2766,
      name: "messages___de"
    }, {
      path: "create",
      component: _469d1018,
      name: "messages-create___de"
    }, {
      path: "inbox",
      component: _1be0271a,
      name: "messages-inbox___de"
    }, {
      path: "sent",
      component: _062961b4,
      name: "messages-sent___de"
    }]
  }, {
    path: "/profile",
    component: _058a02a2,
    children: [{
      path: "",
      component: _e002f0b6,
      name: "profile___de"
    }, {
      path: "settings",
      component: _005260a3,
      name: "profile-settings___de"
    }]
  }, {
    path: "/requests",
    component: _97c5acca,
    children: [{
      path: "",
      component: _650ccfde,
      name: "requests___de"
    }, {
      path: "new",
      component: _620247a2,
      name: "requests-new___de"
    }, {
      path: "submitted",
      component: _bb800cf2,
      name: "requests-submitted___de"
    }, {
      path: "new/:type",
      component: _47940014,
      name: "requests-new-type___de"
    }]
  }, {
    path: "/auth/impersonate",
    component: _4fa62069,
    name: "auth-impersonate___de"
  }, {
    path: "/auth/login",
    component: _4412894e,
    name: "auth-login___de"
  }, {
    path: "/auth/logout",
    component: _2df1b84a,
    name: "auth-logout___de"
  }, {
    path: "/auth/registration",
    component: _d2f37488,
    name: "auth-registration___de"
  }, {
    path: "/auth/t2t",
    component: _a057e534,
    name: "auth-t2t___de"
  }, {
    path: "/download/document",
    component: _7a6561fb,
    name: "download-document___de"
  }, {
    path: "/idAustriaSp/callback",
    component: _a7e3a718,
    name: "idAustriaSp-callback___de"
  }, {
    path: "/idAustriaSp/confirmation",
    component: _059b3ce4,
    name: "idAustriaSp-confirmation___de"
  }, {
    path: "/idAustriaSp/verify",
    component: _31a91730,
    name: "idAustriaSp-verify___de"
  }, {
    path: "/auth/registration/update",
    component: _0292b462,
    name: "auth-registration-update___de"
  }, {
    path: "/auth/registration/verify",
    component: _5a70c502,
    name: "auth-registration-verify___de"
  }, {
    path: "/auth/reset/password",
    component: _7cfed7de,
    name: "auth-reset-password___de"
  }, {
    path: "/auth/reset/user",
    component: _b931026a,
    name: "auth-reset-user___de"
  }, {
    path: "/auth/reset/username",
    component: _267d6a56,
    name: "auth-reset-username___de"
  }, {
    path: "/auth/sso/login",
    component: _40268b59,
    name: "auth-sso-login___de"
  }, {
    path: "/auth/sso/verify",
    component: _1c39688e,
    name: "auth-sso-verify___de"
  }, {
    path: "/profile/settings/delete",
    component: _493ef3aa,
    name: "profile-settings-delete___de"
  }, {
    path: "/profile/settings/email",
    component: _a251e326,
    name: "profile-settings-email___de"
  }, {
    path: "/profile/settings/password",
    component: _f940da4c,
    name: "profile-settings-password___de"
  }, {
    path: "/auth/reset/password/verify",
    component: _893d60c6,
    name: "auth-reset-password-verify___de"
  }, {
    path: "/",
    component: _70f6298b,
    name: "index___de"
  }, {
    path: "/documents/detail/:id",
    component: _c86984e6,
    name: "documents-detail-id___de"
  }, {
    path: "/messages/detail/:id",
    component: _dd360eca,
    name: "messages-detail-id___de"
  }, {
    path: "/requests/detail/:id",
    component: _2ac0d523,
    name: "requests-detail-id___de"
  }, {
    path: "/requests/new/:type?",
    component: _47940014,
    name: "requests-new-type___de"
  }, {
    path: "/*",
    component: _18d5a9d0,
    name: "all___de"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
